/**
 * Turn a tee-time string into a sortable number.
 * • ISO, RFC-2822, or any format the JS engine recognises  →  epoch ms
 * • “HH:mm” or “HH:mm AM/PM”                               →  minutes past midnight (0-1439)
 * • null / empty / unparseable                             →  +Infinity (sorts to the bottom)
 */
export const teeMs = (strTime?: string): number => {
  if (!strTime) return Number.POSITIVE_INFINITY;

  // 1️⃣ First try the built-in parser (covers ISO/RFC strings)
  const builtIn = Date.parse(strTime);
  if (!Number.isNaN(builtIn)) return builtIn;

  // 2️⃣ Try plain 24-hour time: "14:05"
  let m = strTime.match(/^(\d{1,2}):(\d{2})$/);
  if (m) {
    const [, h, mm] = m.map(Number);
    if (h < 24 && mm < 60) return h * 60 + mm; // minutes after midnight
  }

  // 3️⃣ Try 12-hour clock: "8:15 AM" / "12:07 pm"
  m = strTime.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
  if (m) {
    const [, h, mm, ampm] = m;
    let hours = parseInt(h, 10) % 12; // 12 → 0
    if (/pm/i.test(ampm)) hours += 12; // add 12 for PM
    return hours * 60 + parseInt(mm, 10);
  }

  // 4️⃣ Give up – push to the end
  return Number.POSITIVE_INFINITY;
};
